// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-header_layout__tfdxQ","brandPattern":"page-header_brandPattern___kSYP","content":"page-header_content__9GMWj"};